<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title typewriter">Detalles de requerimiento</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="this.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <accordion [isAnimated]="true">
      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-users"></i> Información de creación
        </span>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Numero</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.requirement.number" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Fecha/Hora Creacion</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.parsedCreateDateAndTime" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Area</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.requirement.area" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Tipo</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.requirement.type" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Requiere Adjunto</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.requirement.attachment" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Descripcion</b></label>
          <div class="col-md-9">
            <textarea class="form-control" name="txtDescription" id="txtDescription" cols="30" rows="5"
              [(ngModel)]="this.requirement.description"></textarea>
          </div>
        </div>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngIf="this.requirement.completedBy">
        <span accordion-heading>
          <i class="fa fa-users"></i> Información de confirmación
        </span>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Confirmado por</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.requirement.completedBy" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Fecha/Hora Confirmación</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" disabled
              [(ngModel)]="this.parsedEndDateAndTime" />
          </div>
        </div>
        <div class="form-group row">
          <label for="timer" class="col-form-label col-md-3">
            <b> Tiempo transcurrido:</b></label>
          <app-pos-elapsed-time class="col-md-9" [running]="this.requirement.completedBy === ''"
            [startTime]="this.requirement.createdTimezoneDate"
            [endTime]="this.requirement.confirmationDateTimezoneDate"></app-pos-elapsed-time>
        </div>
      </accordion-group>
      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-comments"></i> Agregar Comentarios
        </span>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Comentarios</b></label>
          <div class="col-md-9">
            <form [formGroup]="commentsForm">
              <textarea class="form-control" name="txtComments" id="" cols="30" rows="10"
                formControlName="comments"></textarea>
            </form>
          </div>
        </div>
      </accordion-group>
      <accordion-group [isOpen]="true" *ngIf="this.requirement.attachment && !this.requirement.completedBy">
        <span accordion-heading>
          <i class="fa fa-paperclip"></i> Adjuntar Documento
          <div class="card-header-actions btn-group" dropdown placement="bottom left">
            <button class="btn btn-sm btn-outline-success" type="button" (click)="showDocuments($event)"
              [disabled]="this.documents.content.length > 0">
              <i class="fa fa-regular fa-file"></i>&nbsp;Agregar
            </button>
          </div>
        </span>
        <pos-table tableFormId="attachedDocumentTable" [data]="documents" [headers]="getAttachedDocumentTableHeaders()"
          [itemsPerPage]="10" [pagination]="false" [disableHighlight]="true"></pos-table>
      </accordion-group>
    </accordion>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="this.close()"
      *ngIf="!this.requirement.completedBy">
      Cancelar
    </button>
    <button type="button" class="btn btn-outline-primary" *ngIf="!this.requirement.completedBy"
      (click)="completeRequirement()">
      Confirmar
    </button>
    <button type="button" class="btn btn-outline-primary" *ngIf="this.requirement.completedBy" (click)="this.close()">
      Cerrar
    </button>
  </div>
</div>